import "./MyModal.css";
import React, {ChangeEvent, CSSProperties, useState} from 'react';
import Modal from 'react-modal';
import Navette from "../../Model/Navette";
import { useRecoilValue } from "recoil";
import { WebApi } from "../../WebApi/WebApi";
import { useUserActions } from "../../../Connect/_actions";
import Collection from "../../Model/Collection";
import { useRecoilState } from "recoil";
import { addDataIntoCache } from "../../Cache/cache";
import SendNewDoc from "../../Pages/SendDocs/SendNewDoc";
import { areCollectionsLoadedAtom, collectionsAtom, externalVerifDocumentsAtom } from "../../LoadData/LoadData";
import { userAtom, windowSizeAtom } from "../../RecoilApp";
import Loc from "../../../Loc/Loc";

enum Using {
    Collection = 0,
    Navette = 1
}

function myCustomStyles(windowWidth: number) {
    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: windowWidth > 800 ? '600px' : '60vw'
        },
    };
    return (customStyles);
}

export function define_button_className(retourClient: string) {
    if (retourClient === "Approuvé") {
        return ("btn btn-success btn-sm");
    }
    if (retourClient === "Approuvé avec commentaires") {
        return ("btn btn-warning btn-sm");
    }
    return ("btn btn-danger btn-sm");
}

export function define_button_text(retourClient: string) {
    if (retourClient === "Approuvé") {
        return (Loc.trad().MyModalApproved);
    }
    if (retourClient === "Approuvé avec commentaires") {
        return (Loc.trad().MyModalApproved);
    }
    if (retourClient === "Refusé") {
        return (Loc.trad().MyModalReceivedRefused);
    }
    return (retourClient);
}

interface MyModalProps {
    className: string;
    style: CSSProperties;
    textButton: string;
    disabled?: boolean;
    element: string;
    navette?: Navette;
    modifyDoc?: boolean;
    item?: any;
    externalDoc?: any;
    isCollection?: boolean;
    collection?: Collection;
}

export default function MyModal(props: MyModalProps) {
    const userActions = useUserActions();
    const user = useRecoilValue(userAtom);
    const windowSize = useRecoilValue(windowSizeAtom);
    const areCollectionsLoaded = useRecoilValue(areCollectionsLoadedAtom);
    const [externalDocs, setExternalDocs] = useRecoilState(externalVerifDocumentsAtom); // à verif
    const [collections, setCollections] = useRecoilState(collectionsAtom);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [comment, setComment] = useState("");
    const [file, setFile] = useState({});
    const [error, setError] = useState("");
    const webApi = new WebApi();
    const isStatusModal: boolean = props.element === "statusModal";
    const isSendNewDocModal: boolean = props.element === "sendNewDocModal";
    const isExternalDocModal: boolean = props.element === "externalDocModal";
    const isRecepModal: boolean = props.element === "recepModal";
    const [fileNumber, setFileNumber] = useState(Loc.trad().MyModalFileEmpty);

    function openModal() {
        isRecepModal && setError("");
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    function updateStatus(status: string) {
        const externalDocId: number = parseInt(props.externalDoc!.id);
        setIsLoading(true);
        userActions.updateExternalDoc(externalDocId, status)
        .then(() => {
            const updatedExternalDocs = JSON.parse(JSON.stringify(externalDocs)).map((doc: any) => {
                if (doc.id === externalDocId) doc.state = status;
                return doc;
            })
            setExternalDocs(updatedExternalDocs);
            setIsLoading(false);
            closeModal();
        })
        .catch(error => {
            console.log(error.message);
            setIsLoading(false);
        })
    }

    const handleInputTextAreaOnChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        setComment(event.target.value);
    }

    const handleFileInputOnChange = (event: ChangeEvent<HTMLInputElement>) => {
        const input = event.target as HTMLInputElement;

        if (!input.files?.length) {
            return;
        }

        const file = input.files[0];
        const files = input.files;
        setFile(file);
        setFileNumber(files.length === 0 ? Loc.trad().MyModalFileEmpty : files.length === 1 ? files.length.toString() + " " + Loc.trad().MyModalFileSingular : files.length.toString() + " " + Loc.trad().MyModalFilePlural);
    }

    const handleReception = (status: string) => {
        setError("");
        setIsLoading(true);
        let newCollections: Collection[] = JSON.parse(JSON.stringify(collections)); // car collections est en read-only donc non modifiable
        let newNavettes: Navette[] = [];
        let updated: number = 0;
        const updateNavRequest = (nav: Navette, type: number) => {
            webApi.updateNav(user.jwtToken, status, comment, nav.id, file)
            .then((newNav: Navette) => {
                if (type === Using.Collection) {
                    let thisCollection: Collection = JSON.parse(JSON.stringify(props.item)); // car props.item est en read-only donc non modifiable
                    newNav.concerneDoc = nav.concerneDoc;
                    newNav.index = nav.index;
                    newNavettes.push(newNav);
                    updated++;
                    if (updated === thisCollection.navettes.length) {
                        thisCollection.navettes = newNavettes;
                        newCollections[thisCollection.index] = thisCollection;
                        setCollections(newCollections);
                        addDataIntoCache('collections', user.username, newCollections);
                        setIsLoading(false);
                        closeModal();
                    }
                }
                if (type === Using.Navette) {
                    let index: number = parseInt(props.item.index);
                    let thisCollection: Collection = JSON.parse(JSON.stringify(props.collection!)); // car props.collection est en read-only donc non modifiable
                    newNav.concerneDoc = thisCollection.navettes[index].concerneDoc;
                    newNav.index = index;
                    thisCollection.navettes[index] = newNav;
                    setIsLoading(false);
                    newCollections[thisCollection.index] = thisCollection;
                    setCollections(newCollections);
                    addDataIntoCache('collections', user.username, newCollections);
                }
            })
            .catch(error => {
                if (type === Using.Collection) {
                    updated++;
                    if (updated === props.item.navettes.length) {
                        setIsLoading(false);
                    }
                    setError(error.message);
                }
                if (type === Using.Navette) {
                    setIsLoading(false);
                    error === "Unauthorized" ? userActions.logout() : setError(error.message);
                }
            })
        }
        if (props.isCollection!) {
            props.item.navettes.forEach((nav: Navette) => {
                updateNavRequest(nav, Using.Collection);
            })
        }
        else {
            updateNavRequest(props.item, Using.Navette);
        }
    }

    return (
        <div className="MyModal">
            <div className="row">
                <div className="col text-right">
                    <button type="button" className={props.className} style={props.style} onClick={openModal} disabled={isRecepModal ? isLoading || !areCollectionsLoaded : props.disabled || false}>
                        <div className="textButton">{props.textButton}</div>
                    </button>
                </div>
            </div>
            <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={myCustomStyles(windowSize.width)} contentLabel="Reception Modal" ariaHideApp={false}>
                {isStatusModal && <StatusHTML></StatusHTML>}
                {isSendNewDocModal && <SendNewDocHTML></SendNewDocHTML>}
                {isExternalDocModal && <ExternalDocHTML></ExternalDocHTML>}
                {isRecepModal && <div className="recepModal"><h3>{Loc.trad().MyModalReceiveTitle}</h3>
                {props.isCollection && <div style={{color:"red"}}>{Loc.trad().MyModalReceiveWarning}<br />{Loc.trad().MyModalReceiveWarning2}</div>}
                <div className="commentaires">
                    <div className="form-group">
                        <label style={{marginBottom: "5px"}}>{Loc.trad().MyModalComments}</label>
                        <textarea className="form-control col-12" rows={5} onChange={handleInputTextAreaOnChange}></textarea>
                    </div>
                </div>
                <div className="mb-3">
                    <div>
                        <label htmlFor="recepFile" className="btn btn-secondary">{Loc.trad().MyModalFile}</label> 
                        <label htmlFor="recepFile" style={{paddingLeft:"10px"}}>{fileNumber}</label> 
                    </div>
                    <input hidden className="form-control" type="file" id="recepFile" onChange={handleFileInputOnChange} />
                </div>{error !== "" && <div style={{color: "red", marginBottom: "10px"}}>{error}</div>}{isLoading && <div style={{marginBottom: "10px"}}>{Loc.trad().MyModalInProgress}<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></div>}<div className="d-grid gap-2 d-md-flex justify-content-md-end"><button className="btn btn-success" onClick={() => handleReception("Approuvé")} disabled={isLoading}>{Loc.trad().MyModalApprove}</button><button className="btn btn-warning" onClick={() => handleReception("Approuvé avec commentaires")} style={{color: "white"}} disabled={isLoading}>{Loc.trad().MyModalApproveComment}</button><button className="btn btn-danger" onClick={() => handleReception("Refusé")} disabled={isLoading}>{Loc.trad().MyModalReject}</button><button className="btn btn-secondary" onClick={closeModal} disabled={isLoading}>{Loc.trad().MyModalCancel}</button></div></div>}
            </Modal>
        </div>
    )

    function StatusHTML() {
        return (
            <div className="statusModal">
                <h3>{Loc.trad().MyModalReceivedTitle}</h3>
                <div className="statutClient">
                    <label className="label">{Loc.trad().MyModalReceivedStatus}</label>
                    <div className="item">{props.navette!.retourClient === "Approuvé avec commentaires" ? Loc.trad().MyModalApprovedWithComment : props.navette!.retourClient === "Approuvé" ? Loc.trad().MyModalApproved : props.navette!.retourClient === "Refusé" ? Loc.trad().MyModalReceivedRefused : props.navette!.retourClient }</div>
                </div>
                <div className="dateRetour">
                    <label className="label">{Loc.trad().MyModalReceivedDate}</label>
                    <div className="item">{props.navette!.dateRetour}</div>
                </div>
                <div className="retourEffectuéPar">
                    <label className="label">{Loc.trad().MyModalReceivedRole}</label>
                    <div className="item">{props.navette!.retourClientPar}</div>
                </div>
                <div className="commentaires">
                    <div className="form-group">
                        <label style={{ marginBottom: "5px" }}>{Loc.trad().MyModalReceivedComments}</label>
                        <textarea className="form-control col-12" rows={5} value={props.navette!.commentaireRetour} disabled></textarea>
                    </div>
                </div>
                <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button className="btn btn-secondary" onClick={closeModal}>{Loc.trad().MyModalReceivedClose}</button>
                </div>
            </div>
        )
    }

    function SendNewDocHTML() {
        return (
            <SendNewDoc closeModal={closeModal} modifyDoc={props.modifyDoc!} item={props.item}></SendNewDoc>
        )
    }

    function ExternalDocHTML() {
        return (
            <div className="externalDocModal">
                {isLoading && <div style={{marginBottom: "10px"}}>{Loc.trad().MyModalExternalInProgress}<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></div>}
                <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button className="btn btn-success" onClick={() => updateStatus("Approuvé")} disabled={isLoading}>{Loc.trad().MyModalExternalApprove}</button>
                    <button className="btn btn-warning" onClick={() => updateStatus("Approuvé avec commentaires")} style={{ color: "white" }} disabled={isLoading}>{Loc.trad().MyModalExternalApproveComment}</button>
                    <button className="btn btn-danger" onClick={() => updateStatus("Refusé")} disabled={isLoading}>{Loc.trad().MyModalExternalReject}</button>
                    <button className="btn btn-secondary" onClick={closeModal} disabled={isLoading}>{Loc.trad().MyModalExternalCancel}</button>
                </div>
            </div>
        )
    }
}